import classNames from 'classnames';
import React from 'react';
import { Edit1Icon } from 'tdesign-icons-react';
import { Button } from 'tdesign-react';

import { BasicImageViewer } from '@/components/review/image';

import { IFileInfo } from '..';
import styles from './index.module.less';

interface IProps {
  value: IFileInfo;
  disabled: boolean;
  colorLoading: boolean;
  removeIcon: JSX.Element;
  openImageDialog: () => void;
  removePic: () => void;
}

// 图片预览和编辑（横向长条形式）
const ImagePreviewAndEdit: React.FC<IProps> = ({
  value,
  disabled,
  colorLoading,
  removeIcon,
  openImageDialog,
  removePic,
}) => (
    <div className={styles.wrapper}>
      <div className={styles.preview}>
        <BasicImageViewer
          hover={false}
          styles={{ background: 'none', width: '100%', height: '100%' }}
          images={[value.url || '']}
          title={value.name}
          showImage={true}
        />
      </div>
      <div className={styles.opration}>
        <div className={styles.btnGroup}>
          <Button
          variant="text"
            icon={<Edit1Icon size={16} />}
          className={classNames(styles.opBtn, {
            ['nova-disabled-opacity']: disabled,
            ['nova-disabled']: disabled,
          })}
            onClick={openImageDialog}
            disabled={colorLoading || disabled}
          />
          <Button
          variant="text"
            icon={removeIcon}
          className={classNames(styles.opBtn, {
            ['nova-disabled-opacity']: disabled,
            ['nova-disabled']: disabled,
          })}
            disabled={disabled}
            onClick={removePic}
          />
        </div>
      </div>
    </div>
);

export default ImagePreviewAndEdit;
